import React from "react";
import { assetsPath } from "../../../../../utils";

export default ({ currentLang, selectedType, selectedBuilding }) => {
  const BG = `${assetsPath(
    "laguna-beachside"
  )}/images/site-plan/${currentLang}/4.jpg`;
  const shouldDisplayByLang = (selectLang) => {
    return currentLang === selectLang ? "display" : "display-none";
  };
  const shouldDisplayByType = (type) => {
    return selectedType === type || selectedType === "all"
      ? "opacity-in"
      : "opacity-out";
  };

  const shouldDisplay = (build, type) => {
    return (selectedType === type || selectedType === "all") &&
      (selectedBuilding === build || selectedBuilding === "all")
      ? "opacity-in"
      : "opacity-out";
  };
  // const shouldDisplay = (build, type) => {
  //   return (selectedType === type || selectedType === "all") &&
  //     selectedBuilding === build
  //     ? "opacity-in"
  //     : "opacity-out";
  // };

  const fill = "#231f20";
  const opacity = 1;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 841.89 595.28"
      className="site-plan-svg"
    >
      <g id="map">
        <image xlinkHref={BG} height="100%" width="100%" />
      </g>
      <g id="floorplan">
        <g className="building-a">
          <g id="1-bed" data-name="1_1" className={shouldDisplay("a", "1-bed")}>
            <polygon
              points="704.2 340.43 703.49 340.39 703.5 340.1 698.75 339.88 698.74 340.14 698.21 340.12 698.22 339.85 693.48 339.63 693.46 339.96 692.93 339.93 692.95 339.61 688.2 339.39 688.19 339.68 687.6 339.65 687.61 339.36 683.06 339.15 684.13 316.12 704.57 317.07 704.68 317.08 705.29 317.11 704.2 340.43"
              fill="#231f20"
              opacity="0.9"
            />
            <polygon
              points="631.96 336.61 632.65 336.71 632.7 336.45 636.85 336.65 636.84 336.94 637.46 337.03 637.58 336.66 641.78 336.92 641.72 337.09 642.25 337.22 642.44 336.9 646.55 337.17 646.54 337.4 647.15 337.46 647.22 337.12 651.42 337.36 651.35 337.71 651.93 337.69 652.01 337.4 656.17 337.7 656.15 337.93 656.76 337.98 656.75 337.67 660.94 337.86 661.93 320.43 632.93 318.94 631.96 336.61"
              fill="#231f20"
              opacity="0.9"
            />
            <polygon
              points="683.55 315.96 683.5 315.95 683.38 315.95 662.94 315 661.87 338.02 666.42 338.23 666.41 338.53 667 338.56 667.01 338.26 671.76 338.48 671.75 338.81 672.28 338.83 672.29 338.51 677.04 338.73 677.02 338.99 677.55 339.01 677.57 338.75 682.23 338.97 683.55 315.96"
              fill="#231f20"
              opacity="0.9"
            />
          </g>
          <g id="2-bed" data-name="1_2" className={shouldDisplay("a", "2-bed")}>
            <rect
              x="609.28"
              y="286.8"
              width="31.13"
              height="27.39"
              transform="translate(18.09 -35.02) rotate(3.26)"
              fill="#231f20"
              opacity="0.9"
            />
            <rect
              x="693.12"
              y="285.47"
              width="31.11"
              height="27.18"
              transform="translate(18.14 -39.79) rotate(3.26)"
              fill="#231f20"
              opacity="0.9"
            />
            <rect
              x="729.77"
              y="324.9"
              width="31.76"
              height="27.18"
              transform="translate(20.44 -41.83) rotate(3.26)"
              fill="#231f20"
              opacity="0.9"
            />
          </g>
          <g id="3-bed" data-name="1_3" className={shouldDisplay("a", "3-bed")}>
            <rect
              x="641.27"
              y="282.86"
              width="41.1"
              height="27.46"
              transform="translate(18.4 -38.04) rotate(3.34)"
              fill="#231f20"
              opacity="0.9"
            />
            <rect
              x="724.64"
              y="292.73"
              width="41.23"
              height="27.46"
              transform="translate(19.11 -42.88) rotate(3.34)"
              fill="#231f20"
              opacity="0.9"
            />
          </g>
        </g>
        <g className="building-b">
          <g id="1-bed" data-name="2_1" className={shouldDisplay("b", "1-bed")}>
            <polygon
              points="402.45 295.4 401.74 295.31 401.77 295.01 397.07 294.37 397.03 294.63 396.51 294.56 396.54 294.3 391.84 293.65 391.79 293.97 391.27 293.9 391.31 293.58 386.61 292.93 386.56 293.22 385.98 293.14 386.02 292.85 381.5 292.23 384.64 269.39 404.91 272.18 405.02 272.19 405.62 272.28 402.45 295.4"
              fill="#231f20"
              opacity="0.9"
            />
            <polygon
              points="456.36 301.56 457.02 301.78 457.11 301.53 461.18 302.43 461.11 302.71 461.71 302.9 461.89 302.56 465.99 303.53 465.89 303.68 466.39 303.9 466.64 303.62 470.64 304.59 470.6 304.81 471.19 304.98 471.32 304.65 475.41 305.61 475.29 305.93 475.86 306.01 475.99 305.75 480.04 306.75 479.97 306.96 480.57 307.12 480.61 306.81 484.71 307.71 488.64 290.7 460.32 284.31 456.36 301.56"
              fill="#231f20"
              opacity="0.9"
            />
            <polygon
              points="570.42 327.42 569.73 327.34 569.75 327.07 565.7 326.14 565.63 326.42 565.01 326.33 564.99 325.94 560.88 325.06 560.9 325.24 560.35 325.22 560.25 324.86 556.22 324.01 556.17 324.23 555.56 324.13 555.59 323.77 551.48 322.87 551.46 323.22 550.9 323.04 550.9 322.75 546.82 321.91 546.78 322.13 546.18 322.02 546.27 321.72 542.18 320.77 545.96 303.72 574.28 310.15 570.42 327.42"
              fill="#231f20"
              opacity="0.9"
            />
            <polygon
              points="513.07 314.12 517 296.99 489.2 290.78 485.49 307.85 489.57 308.78 489.48 309.08 490.09 309.19 490.12 308.97 494.21 309.79 494.21 310.09 494.76 310.26 494.79 309.91 498.9 310.8 498.87 311.15 499.48 311.25 499.54 311.03 503.57 311.87 503.67 312.23 504.22 312.24 504.2 312.06 508.31 312.93 508.34 313.32 508.95 313.41 509.02 313.13 513.08 314.05 513.07 314.12"
              fill="#231f20"
              opacity="0.9"
            />
            <polygon
              points="541.48 320.68 545.4 303.55 517.6 297.34 513.89 314.41 517.98 315.34 517.89 315.64 518.49 315.75 518.53 315.53 522.62 316.36 522.62 316.65 523.17 316.82 523.2 316.48 527.31 317.36 527.28 317.71 527.89 317.81 527.94 317.59 531.97 318.43 532.08 318.79 532.62 318.8 532.61 318.62 536.72 319.5 536.74 319.89 537.36 319.97 537.42 319.69 541.48 320.61 541.48 320.68"
              fill="#231f20"
              opacity="0.9"
            />
          </g>
          <g id="2-bed" data-name="2_2" className={shouldDisplay("b", "2-bed")}>
            <rect
              x="355.62"
              y="232.74"
              width="31.17"
              height="27.14"
              transform="translate(37.17 -48.45) rotate(7.86)"
              fill="#231f20"
              opacity="0.9"
            />
            <rect
              x="350.88"
              y="267.07"
              width="31.17"
              height="27.14"
              transform="translate(41.82 -47.48) rotate(7.86)"
              fill="#231f20"
              opacity="0.9"
            />
            <rect
              x="477.3"
              y="259.51"
              width="31.17"
              height="27.14"
              transform="translate(72.55 -102.19) rotate(12.77)"
              fill="#231f20"
              opacity="0.9"
            />
            <rect
              x="518.13"
              y="268.69"
              width="31.17"
              height="27.14"
              transform="translate(75.59 -110.99) rotate(12.77)"
              fill="#231f20"
              opacity="0.9"
            />
          </g>
          <g id="3-bed" data-name="2_3" className={shouldDisplay("b", "3-bed")}>
            <rect
              x="386.81"
              y="240.25"
              width="41.1"
              height="27.53"
              transform="translate(39.37 -54.28) rotate(8.01)"
              fill="#231f20"
              opacity="0.9"
            />
            <rect
              x="437.24"
              y="248.05"
              width="41.1"
              height="27.25"
              transform="translate(68.96 -94.5) rotate(12.74)"
              fill="#231f20"
              opacity="0.9"
            />
            <rect
              x="549.93"
              y="273.5"
              width="41.1"
              height="27.25"
              transform="translate(77.35 -118.72) rotate(12.74)"
              fill="#231f20"
              opacity="0.9"
            />
          </g>
        </g>
        <g className="building-c">
          <g id="2-bed" data-name="3_2" className={shouldDisplay("c", "2-bed")}>
            <rect
              x="75.52"
              y="229.21"
              width="31.31"
              height="27.44"
              fill="#231f20"
              opacity="0.9"
            />
            <rect
              x="99.52"
              y="263.96"
              width="31.06"
              height="27.26"
              fill="#231f20"
              opacity="0.9"
            />
            <rect
              x="131.37"
              y="266.82"
              width="31.21"
              height="27.26"
              fill="#231f20"
              opacity="0.9"
            />
            <rect
              x="170.32"
              y="264.01"
              width="31.21"
              height="27.26"
              fill="#231f20"
              opacity="0.9"
            />
            <rect
              x="297.45"
              y="264.01"
              width="31.21"
              height="27.26"
              fill="#231f20"
              opacity="0.9"
            />
            <rect
              x="202.2"
              y="266.92"
              width="31.21"
              height="27.26"
              fill="#231f20"
              opacity="0.9"
            />
            <rect
              x="265.57"
              y="266.92"
              width="31.21"
              height="27.26"
              fill="#231f20"
              opacity="0.9"
            />
            <rect
              x="205.83"
              y="229.21"
              width="31.31"
              height="27.44"
              fill="#231f20"
              opacity="0.9"
            />
          </g>
          <g id="3-bed" data-name="3_3" className={shouldDisplay("c", "3-bed")}>
            <rect
              x="107.64"
              y="232.09"
              width="40.95"
              height="27.32"
              fill="#231f20"
              opacity="0.9"
            />
            <rect
              x="156.45"
              y="232.09"
              width="41.74"
              height="27.32"
              fill="#231f20"
              opacity="0.9"
            />
            <rect
              x="237.93"
              y="232.09"
              width="41.07"
              height="27.32"
              fill="#231f20"
              opacity="0.9"
            />
            <rect
              x="286.87"
              y="232.09"
              width="41.82"
              height="27.32"
              fill="#231f20"
              opacity="0.9"
            />
          </g>
        </g>
        <g className="building-d">
          <g id="1-bed" data-name="4_1" className={shouldDisplay("d", "1-bed")}>
            <rect
              id="_4106"
              data-name="4106"
              x="405.9"
              y="320.5"
              width="23.4"
              height="21.27"
              fill="#231f20"
              opacity="0.9"
            />
            <rect
              id="_4107"
              data-name="4107"
              x="405.9"
              y="341.7"
              width="23.4"
              height="21.97"
              fill="#231f20"
              opacity="0.9"
            />
            <rect
              id="_4108"
              data-name="4108"
              x="405.9"
              y="428.5"
              width="23.1"
              height="21.3"
              fill="#231f20"
              opacity="0.9"
            />
            <polygon
              id="_4109"
              data-name="4109"
              points="429 449.8 405.9 449.8 405.9 471 428.8 471 429 449.8"
              fill="#231f20"
              opacity="0.9"
            />
            <rect
              id="_4110"
              data-name="4110"
              x="405.9"
              y="471"
              width="22.9"
              height="21.94"
              fill="#231f20"
              opacity="0.9"
            />
          </g>
          <g id="2-bed" data-name="4_2" className={shouldDisplay("d", "2-bed")}>
            <polygon
              id="_4101"
              data-name="4101"
              points="460.9 484.5 433.6 484.5 433.6 452.5 461 452.5 460.9 484.5"
              fill="#231f20"
              opacity="0.9"
            />
            <polygon
              id="_4102"
              data-name="4102"
              points="464.4 421.3 464.4 453.3 436.8 453.3 436.8 421.3 464.4 421.3"
              fill="#231f20"
              opacity="0.9"
            />
            <polygon
              id="_4103"
              data-name="4103"
              points="433.5 422.1 433.5 390.9 461 390.9 461 422.1 433.5 422.1"
              fill="#231f20"
              opacity="0.9"
            />
            <polygon
              id="_4104"
              data-name="4104"
              points="437 359 464.4 359 464.4 391 436.8 391 437 359"
              fill="#231f20"
              opacity="0.9"
            />
            <polygon
              id="_4105"
              data-name="4105"
              points="433.5 327.8 461 327.8 461 359.7 433.5 359.7 433.5 327.8"
              fill="#231f20"
              opacity="0.9"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};



// WEBPACK FOOTER //
// ./src/data/LagunaBeachside/sitePlan/svg/floor/4.js